import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

export const useSyncQueryParamInLocalStorage = (name: string) => {
  const [params] = useSearchParams();

  useEffect(() => {
    const currentSearchParam = params.get(name);

    if (currentSearchParam) {
      localStorage.setItem(name, currentSearchParam);
    }
  }, [name, params]);

  return {
    getLocalStorageValue: () => localStorage.getItem(name),
  };
};
